import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";
import { similarwebValueType } from "app/pages/sales-intelligence/common-components/export-table/valueType";

export const REQUESTER_EMAIL = "requester_email";

export const getRequesterFieldsConfig = (): Readonly<SimilarwebFieldsConfig> => {
    const config: SimilarwebFieldsConfig = {
        [REQUESTER_EMAIL]: {
            name: "Exporter's email",
            example: "john.doe@similarweb.com",
            field: "requester_email",
            valueType: similarwebValueType.Text,
        },
    };

    return Object.seal(config);
};

export const getRequesterFieldsKeys = () => Object.keys(getRequesterFieldsConfig());
